import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { nrCellAvailabilityNrCellChartConfig } from '../cellChartConfigs';

/**
 * Props for the NrCellAvailabilityNrCell component
 */
interface NrCellAvailabilityNrCellProps {
  /** Name of the NR cell */
  cellName: string;
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * NR Cell Availability Chart (NR Cell Level)
 * 
 * Displays cell availability percentage for individual NR cells.
 * Tracks cell uptime and operational status.
 * 
 * @component
 * @see {@link ../cellChartConfigs.ts} - Chart configuration (nrCellAvailabilityNrCellChartConfig)
 * @see API: /api/nr/cell/availability?cell_name={cellName}
 */

const NrCellAvailabilityNrCell: React.FC<NrCellAvailabilityNrCellProps> = ({ 
  cellName, 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  // Memoize additionalParams to prevent infinite re-renders
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);

  return (
    <SiteCharts 
      config={nrCellAvailabilityNrCellChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
      additionalParams={additionalParams}
    />
  );
};

export default NrCellAvailabilityNrCell;
